type CapacitorLike = {
  isNativePlatform?: () => boolean;
};

export function isNativeCapacitorPlatform(): boolean {
  const globalCapacitor = globalThis as typeof globalThis & {
    Capacitor?: CapacitorLike;
  };

  return globalCapacitor.Capacitor?.isNativePlatform?.() === true;
}
